<template>
<div v-if="data" class="chart-group">
  <div>
    <dimension-weather-chart
      v-if="hasAllWindFactor"
      ref="chart"
      :data-config="data"
      :dimension="0"
      :unit-prop="unitProp"
      download-name="臭氧污染概况分析"
      chart-min-height="300px"
    >
    </dimension-weather-chart>
    <x-y-chart
      v-else
      ref="chart"
      :data-config="data"
      :unit-prop="unitProp"
      chart-type="line"
      :stack-type="1"
      download-name="臭氧污染概况分析"
      chart-min-height="300px"
      chart-height="auto"
      selected-change-with-data-changed
      need-resize
    >
    </x-y-chart>
  </div>
</div>
</template>

<script>
import BaseStore from '../../../../components/BaseStore'
import DataFormatter from '../../../../model/DataFormatter'
import DimensionWeatherChart from '../../../../components/Data/ChartWrapper/DimensionWeatherChart'
import XYChart from '../../../../components/DataChart/XYChart'

export default {
  name: 'ChartGroup',
  components: {XYChart, DimensionWeatherChart},
  extends: BaseStore,
  props: {
    site: {
      required: true,
      type: Object
    },
    defaultFactorIds: {
      required: true,
      type: Array
    },
    originalData: {
      required: true,
      type: Array
    },
    unitProp: {
      required: true,
      type: String
    },
    query: {
      required: true,
      type: Object
    },
    siteFactorMap: {
      required: true,
      type: Object
    },
    factorSiteMap: {
      required: true,
      type: Object
    },
    completeAllData: {
      required: true,
      type: Boolean
    },
    dimension: {
      required: true,
      type: Number
    },
    noDataReasonMap: {
      required: true,
      type: Object
    },
    filterSiteMap: {
      required: true,
      type: Object
    }
  },
  data: () => ({
    visible: false,
    factorIds: [],
    data: null
  }),
  computed: {
    hasAllWindFactor () {
      const windFactorIds = this.data.dimensions.reduce((list, dimension) => {
        const {factorId} = dimension

        if (/^(1012|1013)$/.test(factorId)) {
          list.push(factorId)
        }

        return list
      }, [])

      return windFactorIds.includes('1012') && windFactorIds.includes('1013')
    },
    devices () {
      return JSON.parse(JSON.stringify(this.site.devices)).map(device => ({
        id: device.id,
        name: device.name,
        children: Object.values(device.siteDeviceFactors.reduce((map, factor) => {
          const {factorId} = factor
          map[factorId] = {
            id: factorId,
            name: factor.name
          }

          return map
        }, {}))
      }))
    }
  },
  methods: {
    init () {
      this.currentQuery = {
        ...this.query,
        factorIds: this.factorIds = this.defaultFactorIds
      }
    },
    getData () {
    },
    setData (dataList) {
      this.tmpList = Object.freeze(DataFormatter.formatWeatherDataList.bind(this)(dataList))
      this.setFormatData()

      setTimeout(() => {
        this.$emit('rendered')
      }, 0)
    },
    setFormatData () {
      this.formatData()
      this.data = Object.freeze(this.formatVOCsData())
    },
    formatData: DataFormatter.format2,
    formatVOCsData () {
      const {dataList, factorGroupMap} = this
      const [dataConfig] = dataList
      const dimensions = []
      const vocsDimensions = []
      const vocsGroupMap = dataConfig.dimensions.reduce((map, factor) => {
        if (factor.rootFactorId === 'VOC') {
          const {parentId} = factor

          if (!map[parentId]) {
            const factorGroup = factorGroupMap[parentId]

            if (factorGroup) {
              map[parentId] = {
                ...factor,
                ...factorGroup,
                factorId: parentId,
                seriesParam: {
                  type: 'line',
                  showSymbol: false,
                  areaStyle: {},
                  stack: 'VOCs'
                }
              }
            }
          }

          vocsDimensions.push(factor)
        } else {
          dimensions.push(factor)
        }

        return map
      }, {})

      const vocsGroups = Object.values(vocsGroupMap)

      if (vocsGroups.length === 0) {
        return dataConfig
      }

      const {seriesMap, dataTimes} = dataConfig
      const newSeriesMap = vocsGroups.reduce((map, vocsGroup) => {
        map[vocsGroup.factorId] = {}
        return map
      }, dimensions.reduce((map, dimension) => {
        const {factorId} = dimension
        map[factorId] = seriesMap[factorId]
        return map
      }, {}))

      return {
        ...dataConfig,
        dimensions: vocsGroups.concat(dimensions),
        seriesMap: vocsDimensions.reduce((map, dimension) => {
          const {parentId, factorId} = dimension
          const dataMap = seriesMap[factorId]
          const newDataMap = map[parentId]

          return dataTimes.reduce((map, dataTime) => {
            dataTime = dataTime[1]
            const oldData = dataMap[dataTime]

            if (oldData) {
              const { value } = oldData
              if (Number.isFinite(value)) {
                let newData = newDataMap[dataTime]

                if (!newData) {
                  newData = newDataMap[dataTime] = {
                    ...oldData,
                    value: 0
                  }
                }

                newData.value += value
              }
            }

            return map
          }, map)
        }, newSeriesMap)
      }
    },
    onSelectFactorBtnClick () {
      this.visible = true
    },
    onOkBtnClick () {
      this.currentQuery.factorIds = this.factorIds
      this.visible = false
    },
    onCancelBtnClick () {
      this.visible = false
    },
    getChartComponent () {
      return this.$refs.chart.getChartComponent()
    }
  },
  watch: {
    site () {
      this.init()
    },
    query () {
      this.currentQuery = {
        ...this.query,
        factorIds: this.factorIds
      }
    },
    unitProp () {
      this.setFormatData()
    },
    originalData: {
      immediate: true,
      handler (data) {
        if (!data.length) return
        let {defaultFactorIds} = this
        let factorIdsMap = defaultFactorIds.reduce((map, el) => {
          map[el] = el
          return map
        }, {})
        let temp = data.filter(el => factorIdsMap[el.factorId])
        setTimeout(() => {
          this.setData(temp)
        }, 0)
      }
    }
  },
  created () {
    this.init()
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/01Photochemical/01OzonePollutantAnalysis/ChartGroup.vue